import { ReactNode } from "react";
import { AccessDenied } from "../access/access-denied";
import { isRtkStatus } from "@/lib/http/rtk-error";

interface UseForbiddenFallbackOptions {
  error: unknown;
  onBack?: () => void;
  message?: string;
  backLabel?: string;
}

/**
 * Hook that returns a fallback UI component if the error is a 403 Forbidden
 * @param options - Configuration for the forbidden fallback
 * @returns ReactNode to render for 403 errors, or null if no error or not 403
 */
export function useForbiddenFallback({
  error,
  onBack,
  message,
  backLabel
}: UseForbiddenFallbackOptions): ReactNode | null {
  if (!error) {
    return null;
  }

  if (isRtkStatus(error, 403)) {
    return (
      <AccessDenied 
        message={message}
        onBack={onBack}
        backLabel={backLabel}
      />
    );
  }

  return null;
}

